module.exports = __webpack_public_path__ + "img/logo.a7457ecf.svg";